import { RightsRole } from "@ac-expo/api-types";
import { privateAxios } from "../axiosInstances";
import { useQuery } from "@tanstack/react-query";
import rightsQueryKeys from "../query-keys/rights.query-keys";

const getRightsRoles = async (asAcExpo?: boolean) => {
  const url = asAcExpo ? "/rights/ac-expo" : "/rights";

  const { data } = await privateAxios.get<RightsRole[]>(url);

  return data;
};

export const useGetRightsRolesQuery = (asAcExpo?: boolean) => {
  return useQuery({
    queryKey: rightsQueryKeys.list(asAcExpo),
    queryFn: () => getRightsRoles(asAcExpo),
  });
};
